import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgDriving = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="M15.739 8.15c.09 0 .173.05.214.13l.778 1.52a.24.24 0 0 1-.213.35h-6.186a.24.24 0 0 1-.212-.352l.798-1.52a.24.24 0 0 1 .213-.129z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M10.06 4.812a2 2 0 0 0-1.732.999l-3.06 5.296a2 2 0 0 0-.269 1v1.908a2 2 0 0 0 2 2h.055a2.781 2.781 0 0 0 5.471-.001h3.977a2.781 2.781 0 0 0 5.472-.001H22a2 2 0 0 0 2-2V11.19a2 2 0 0 0-1.348-1.89l-2.762-.955-1.605-2.588a2 2 0 0 0-1.7-.946zm11.517 9.2h.422v-2.82l-2.762-.955A2 2 0 0 1 18.19 9.4l-1.604-2.588H10.06L7 12.108v1.906h.45a2.78 2.78 0 0 1 2.34-1.278c.982 0 1.845.51 2.34 1.278h4.768a2.78 2.78 0 0 1 2.34-1.278c.981 0 1.844.509 2.339 1.277M10.57 15.518a.78.78 0 1 1-1.56 0 .78.78 0 0 1 1.56 0m9.448 0a.78.78 0 1 1-1.56 0 .78.78 0 0 1 1.56 0"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      d="M1.16 14.617a.9.9 0 0 1 .9-.9H3.31a.9.9 0 1 1 0 1.8H2.06a.9.9 0 0 1-.9-.9M.9 10.924a.9.9 0 0 0 0 1.8h2.461a.9.9 0 1 0 0-1.8z"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgDriving);
export default Memo;
